import { uploadQuene } from './upload.process.js';
// base64转换成file
function baset64ToFile (base64, fileName) {
    // 将base64转换为文件
    var arr = base64.split(',');
    var mime = arr[0].match(/:(.*?);/)[1];
    var bstr = atob(arr[1]);
    var n = bstr.length;
    var u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], fileName, { type: mime });
}

function getList (rawFile, options) {
    let fileList = [];
    console.log('base64file', rawFile);
    fileList.push({ rawFile: rawFile, url: '', md5: '', status: 'ready', progress: 0, downUrl: '', errMsg: '', options: options });
    return fileList;
}

function base64Upload (base64, fileName, options) {
    let rawFile = baset64ToFile(base64, fileName);
    let list = getList(rawFile, options);
    uploadQuene(list, { uploadUrl: options.uploadUrl });
}

function fileUpload (rawFile, fileName, options) {
    let list = getList(rawFile, options);
    uploadQuene(list, { uploadUrl: options.uploadUrl });
}

export { base64Upload, fileUpload };
